import { arrayWithoutSubset, setFulfilled, setPending } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type { SuggestedGroupsDismissFulfilledAction } from '../../domains/suggestedGroupDismiss/actions.types';
import type {
  SuggestedGroupsLoadAction,
  SuggestedGroupsLoadFulfilledAction,
} from '../../domains/suggestedGroups/loadActions.types';
import type {
  SuggestedGroupsLoadMoreAction,
  SuggestedGroupsLoadMoreFulfilledAction,
} from '../../domains/suggestedGroups/loadMoreActions.types';

import type { ViewerSuggestedGroupIdSets } from './types';

const loadMoreSuggestedGroupFulfilled = (
  state: ViewerSuggestedGroupIdSets,
  action: SuggestedGroupsLoadMoreFulfilledAction
) => {
  if (!state.fulfilled) {
    return setFulfilled({ ...action.payload.entities.viewerSuggestedGroupIdSets, dismissedSuggestedGroupIds: [] });
  }

  return {
    ...state,
    fulfilled: {
      ...state.fulfilled,
      suggestedGroupIds: [
        ...new Set([
          ...state.fulfilled.suggestedGroupIds,
          ...arrayWithoutSubset(
            action.payload.entities.viewerSuggestedGroupIdSets.suggestedGroupIds,
            state.fulfilled.dismissedSuggestedGroupIds
          ),
        ]),
      ],
    },
  };
};

const loadSuggestedGroupFulfilled = (state: ViewerSuggestedGroupIdSets, action: SuggestedGroupsLoadFulfilledAction) => {
  if (!state.fulfilled) {
    return setFulfilled({ ...action.payload.entities.viewerSuggestedGroupIdSets, dismissedSuggestedGroupIds: [] });
  }

  return {
    ...state,
    fulfilled: {
      ...state.fulfilled,
      suggestedGroupIds: arrayWithoutSubset(
        action.payload.entities.viewerSuggestedGroupIdSets.suggestedGroupIds,
        state.fulfilled.dismissedSuggestedGroupIds
      ),
    },
  };
};

const dismissSuggestedGroupFulfilled = (
  state: ViewerSuggestedGroupIdSets,
  action: SuggestedGroupsDismissFulfilledAction
) => {
  if (!state.fulfilled) {
    return state;
  }

  return {
    ...state,
    fulfilled: {
      suggestedGroupIds: state.fulfilled.suggestedGroupIds.filter((id) => id !== action.payload.groupId),
      dismissedSuggestedGroupIds: [...state.fulfilled.dismissedSuggestedGroupIds, action.payload.groupId],
    },
  };
};

export const initialState: ViewerSuggestedGroupIdSets = {
  pending: false,
  fulfilled: undefined,
  rejected: undefined,
};

export type ViewerSuggestedGroupIdSetsAction =
  | SuggestedGroupsLoadAction
  | SuggestedGroupsLoadMoreAction
  | SuggestedGroupsDismissFulfilledAction;

const reducer: Reducer<ViewerSuggestedGroupIdSets, ViewerSuggestedGroupIdSetsAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'SUGGESTED_GROUPS.LOAD_PENDING': {
      if (!state.fulfilled) {
        return setPending();
      }

      return { ...state, fulfilled: { ...state.fulfilled, suggestedGroupIds: [] } };
    }
    case 'SUGGESTED_GROUPS.LOAD_FULFILLED':
      return loadSuggestedGroupFulfilled(state, action);
    case 'SUGGESTED_GROUPS.LOAD_MORE_FULFILLED':
      return loadMoreSuggestedGroupFulfilled(state, action);
    case 'SUGGESTED_GROUPS.DISMISS_FULFILLED':
      return dismissSuggestedGroupFulfilled(state, action);
    default:
      return state;
  }
};

export default reducer;
